import {Button} from '@/components/ui/button/Button'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Text} from '@/components/ui/text/Text'
import {useGetInfiniteNotifications} from '@/features/notifications/queries/useGetInfiniteNotifications'
import {IconContainer} from '@/components/ui/icon-container/IconContainer'
import {Bell01Icon} from '@/components/ui/icon/Icon'
import {StyledHomeCard} from './style'
import {HomeNotificationsSkeleton} from './HomeNotificationsSkeleton'
import {useTranslation} from 'react-i18next'
import {NotificationsModal} from '@/features/notifications/components/notifications-modal/NotificationsModal'
import {useState} from 'react'

export const HomeNotificationsCard = () => {
    const {t} = useTranslation()
    const {notifications, isLoading} = useGetInfiniteNotifications(true, 3)
    const hasNotifications = notifications.length > 0
    const [isModalOpen, setIsModalOpen] = useState(false)

    const handleOpenModal = () => {
        setIsModalOpen(true)
    }

    const handleCloseModal = () => {
        setIsModalOpen(false)
    }

    return (
        <StyledHomeCard>
            <Flexbox direction="column" gap={6} fullWidth>
                <Flexbox align="center" gap={4}>
                    <IconContainer size="lg" variant="primary">
                        <Bell01Icon />
                    </IconContainer>
                    <Text size="textXl" weight={500} palette="neutral" shade="600">
                        Ultime notifiche
                    </Text>
                </Flexbox>

                {isLoading && !hasNotifications ? (
                    <HomeNotificationsSkeleton />
                ) : !hasNotifications ? (
                    <Flexbox fullWidth gap={2} direction="column" align="center" justify="center">
                        <Bell01Icon size={18} />
                        <Text size="textSm" palette="neutral" shade="500">
                            {t('homepage:no_notifications_to_read')}
                        </Text>
                    </Flexbox>
                ) : (
                    <Flexbox direction="column" gap={2}>
                        {notifications.map(notification => (
                            <Flexbox align="center" gap={3} key={notification.id}>
                                <Flexbox align="center" gap={1}>
                                    <Text size="textLg" weight="500" palette="neutral" shade="900">
                                        •
                                    </Text>
                                    <Text size="textMd" weight="500" palette="neutral" shade="900">
                                        {notification.notification.title}
                                    </Text>
                                </Flexbox>
                                {notification.notification.extraData && (
                                    <Text size="textXs" palette="neutral" shade="700">
                                        {notification.notification.extraData.patientName && (
                                            <span>{notification.notification.extraData.patientName}</span>
                                        )}
                                        {notification.notification.extraData.projectCode && (
                                            <span> • PRI n°{notification.notification.extraData.projectCode}</span>
                                        )}
                                        {notification.notification.type === 'Age-001-Repeated' && (
                                            <span> • {notification.notification.bodyTemplate}</span>
                                        )}
                                    </Text>
                                )}
                            </Flexbox>
                        ))}
                    </Flexbox>
                )}
            </Flexbox>

            <Button variant="secondary" size="sm" onClick={handleOpenModal}>
                Vedi tutto
            </Button>
            <NotificationsModal isOpen={isModalOpen} onClose={handleCloseModal} />
        </StyledHomeCard>
    )
}
